<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новая категория</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="category_name"
                        v-model="category.name"
                        v-validate="'required|max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        solo
                        text
                        required/>
                </v-flex>

                <v-flex xs12 mb-4>
                    <v-layout>
                        <upload-img :image-width="1024" :image-height="1024" v-model="category.img"
                                    style="max-width: 253px;">
                            <div slot="activator">
                                <v-avatar size="200px" v-ripple class="grey lighten-3" tile v-if="!category.img">
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для категории"/>
                                </v-avatar>
                                <v-avatar size="200px" v-ripple tile v-else>
                                    <img :src="category.img.imageURL" alt="Изображение для категории"/>
                                </v-avatar>
                            </div>
                        </upload-img>

                        <v-flex xs5 offset-xs1>
                            <v-subheader class="pa-0">emoji (для ботов)</v-subheader>
                            <v-text-field
                                ref="category_emoji"
                                v-model="category.emoji"
                                v-validate="'required'"
                                data-vv-name="emoji"
                                :error-messages="errors.collect('emoji')"
                                single-line
                                solo
                                text
                                required/>

                            <v-subheader class="pa-0">Позиция</v-subheader>
                            <v-text-field
                                mask="###"
                                ref="category_position"
                                v-model="category.position"
                                single-line
                                text
                                solo/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="category.status ? 'Включен' : 'Отключен'" v-model="category.status"
                                        class="mt-0"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Описание</v-subheader>
                    <v-textarea
                        ref="category_description"
                        v-model="category.description"
                        v-validate="'required|max:140'"
                        :error-messages="errors.collect('description')"
                        data-vv-name="description"
                        single-line
                        solo
                        text
                        required
                        counter="140"/>
                </v-flex>

                <v-flex xs12>
                    <v-subheader class="pa-0">Рекомендованный товары к этой категории</v-subheader>
                    <v-combobox
                        solo
                        text
                        multiple
                        small-chips
                        hide-selected
                        item-value="id"
                        item-text="name"
                        :items="products"
                        deletable-chips
                        v-model="category.recommended"
                        label="Выберите необходимое">
                        <template slot="no-data">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Пусто? Добавьте продукты и попробуйте снова
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                </v-flex>

                <v-flex class="mt-5" xs12>
                    <v-subheader class="pa-0">Аттрибуты для товаров категорий</v-subheader>
                    <v-combobox
                        solo
                        text
                        multiple
                        small-chips
                        hide-selected
                        item-value="id"
                        item-text="key"
                        :items="attrs"
                        deletable-chips
                        v-model="category.attrs"
                        label="Выберите необходимое">
                        <template slot="no-data">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Пусто? Значит закончились или не были добавлены аттрибуты
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-combobox>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Category from '../../../api/category'
    import Attr from '../../../api/attr'
    import Products from '../../../api/product'
    import UploadImg from '../../../components/Media/Upload'

    export default {
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        name: 'addCategory',
        data: () => ({
            blankImg: '',
            loading: false,
            category: {
                img: '',
                name: '',
                emoji: '',
                position: 1,
                status: true,
                description: '',
                recommended: [],
                attrs: []
            },
            products: [],
            attrs: [],
            dictionary: {
                custom: {
                    name: {
                        required: 'Введите название для категории',
                        max: 'Превышено максимальное количество символов в названии'
                    },
                    description: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов в описании'
                    },
                    emoji: {
                        required: 'Emoji не поставлен'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)

            Products
                .getAll()
                .then(response => this.products = response.data.data)
                .catch(error => new Error(error))

            Attr
                .getAll()
                .then(response => this.attrs = response.data.data)
                .catch(error => new Error(error))
        },
        methods: {
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Category
                            .add(this.category)
                            .then(response => {
                                response.data.data.products = []
                                this.$store.commit('addCategory', response.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Категория добалена',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'categoryRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>

<style lang="scss">
    @import "../../../assets/styles/colors";
    @import "../../../assets/styles/fonts";

    .layout {
        &-add {
            background: $layoutBg;
        }
    }

    .form {
        &-add {
            .primary--text {
                color: black !important;
                caret-color: black !important;
            }

            .v {
                &-subheader {
                    height: 26px;
                    font: 300 0.875rem $fontFamily;
                }
            }
        }
    }
</style>
